import { Check, Clock3, Layers3, Users } from 'lucide-react'
import PageHero from '../components/PageHero'
import SectionTitle from '../components/SectionTitle'
import { capabilities, learningLevels } from '../data'

export default function Programs() {
  return (
    <>
      <PageHero eyebrow="Programs & curriculum" title="A curriculum that grows with the learner." text="Qubispark pathways are structured around increasing depth—from understanding tools to applying connected workflows and building AI-enabled solutions." image="https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1400&q=88" imageAlt="Students collaborating during a learning session" metric="3 levels" metricLabel="One connected capability journey" />
      <section className="section levels-detail">
        <div className="container">
          <SectionTitle eyebrow="Curriculum depth" title="Starter, medium and advanced describe the learning—not a pricing tier." text="Learners can begin at the depth that matches their experience. Programs are then tailored by audience, domain and desired application." />
          <div className="level-tracks">
            {learningLevels.map((level, index) => (
              <article className="level-track" key={level.label}>
                <div className="level-track__head"><span>{level.number}</span><div><small>Learning depth</small><h2>{level.label}</h2></div></div>
                <div className="level-track__main"><h3>{level.title}</h3><p>{level.text}</p></div>
                <ul>{level.outcomes.map(item => <li key={item}><Check size={16} />{item}</li>)}</ul>
                {index < learningLevels.length - 1 && <div className="track-connector" />}
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="section curriculum-map">
        <div className="container">
          <SectionTitle eyebrow="Curriculum map" title="Areas learners can explore." text="Modules are composed to suit learner context, from non-technical discovery to hands-on application development." align="center" />
          <div className="capability-grid capability-grid--programs">
            {capabilities.map(({ icon: Icon, title, text }, index) => <article className="program-topic" key={title}><span>0{index + 1}</span><Icon size={24} /><h3>{title}</h3><p>{text}</p></article>)}
          </div>
        </div>
      </section>
      <section className="section formats-section">
        <div className="container formats-grid">
          <div><span className="eyebrow">Flexible formats</span><h2>Designed around your learning environment.</h2><p>Programs can be delivered in person, virtually or as a blended experience. Duration and pacing follow the complexity of the outcome—not a fixed catalogue.</p></div>
          <div className="format-list">
            <p><Clock3 /><span><b>Focused workshops</b><small>High-energy introductions and targeted skill building.</small></span></p>
            <p><Layers3 /><span><b>Multi-session pathways</b><small>Structured progression with practice between sessions.</small></span></p>
            <p><Users /><span><b>Labs and bootcamps</b><small>Intensive builds, coaching and project demonstrations.</small></span></p>
          </div>
        </div>
      </section>
    </>
  )
}
